module.exports = __webpack_public_path__ + "img/home-fqa-cat-hand.7c76c4ad.svg";